








import { Component, Ref, Vue } from "vue-property-decorator";
import TariffZone from "../Tarification/TariffZone.vue";
import { TarificationTypes, TarificationTransports } from "@/store/tarification/types";

// Component.registerHooks(['beforeRouteLeave']); // Почему-то без этого работает...

@Component({ components: { TariffZone } })
export default class CallPartnerTariffZone extends Vue {
  @Ref("tariffZone") tariffZone!: TariffZone;

  private partnerType: TarificationTypes = TarificationTypes.PARTNER;
  private tarificationTransport: TarificationTransports = TarificationTransports.CALL;

  beforeRouteLeave(to: any, from: any, next: any) {
    this.tariffZone.beforeLeave(to, from, next);
  }
}
